<!--  -->
<template>
  <div class="page" :class="{ inApp: $root.$data.isApp || this.$root.miniprogram}">
    <common-title titleName="预览发票" :zIndex="1000"></common-title>
    <div class="pdf">
      <pdf :pdfUrl="pdfUrl[idx - 1]" />
    </div>
    <div class="btn">
      <div class="left" @click="change(0)"></div>
      <div class="middle">{{ idx }}/{{ pdfUrl.length }}</div>
      <div class="right" @click="change(1)"></div>
    </div>
    <div class="foot" @click="downFile">
      <div>下载发票</div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import pdf from '@/pages/examOutline/components/pdf.vue';

export default {
  components: {
    pdf,
  },
  data() {
    return {
      pdfUrl: [
       
      ],
      idx: 1,
    };
  },
  computed: {},
  watch: {},
  methods: {
    change(type) {
      if (type == 1) {
        this.idx = this.idx >= this.pdfUrl.length ? this.pdfUrl.length : this.idx + 1;
      } else {
        this.idx = this.idx === 1 ? 1 : this.idx - 1;
      }
    },
      downFile() {
      const pdfUrl = this.pdfUrl[this.idx-1];
      this.openPdf(pdfUrl);
    },
    openPdf(pdfUrl) {
      console.log(pdfUrl,1111)
      if (this.$root.$data.isApp) {
        this.$sendToApp('openBrowser', { url: pdfUrl }, false);
        return;
      }
      const fileName = '电子发票';
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/professionalCourseBank/openPdfFile/openPdfFile?pdfUrl=${pdfUrl}&fileName=${decodeURIComponent(fileName)}`,
        });
        return;
      }
      window.open(pdfUrl);
    },
  },
  created() {},
  mounted() {
    const pdfLinks=JSON.parse(window.sessionStorage.getItem('pdfLinks'))
    this.pdfUrl=pdfLinks;
  },
};
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  padding: 129px 36px 0 36px;
  background: #f7f8fc;
}
.inApp {
  padding-top: 36px;
}
.pdf {
  min-height: 400px;
}
.btn {
  display: flex;
  justify-content: center;
  margin-top: 43px;
  .left {
    width: 65px;
    height: 65px;
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invoice/arrow2.png');
    background-size: 100%;
  }
  .right {
    width: 65px;
    height: 65px;
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invoice/arrow1.png');
    background-size: 100%;
  }
  .middle {
    width: 109px;
    height: 65px;
    margin: 0 22px;
    color: #ff7f41;
    font-weight: 500;
    font-size: 25px;
    line-height: 65px;
    text-align: center;
    background: #fff;
    border-radius: 11px;
  }
}
.foot {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 750px;
  height: 167px;
  background: #fff;
  border-radius: 22px 22px 2px 2px;
  box-shadow: 0 -4px 14px 0 rgba(0, 0, 0, 0.05);
  div {
    width: 678px;
    height: 80px;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #ff7f41;
    border-radius: 49px;
  }
}
</style>
